import { computed } from 'vue';
import { useCompanyStore } from '@/modules/company/store';

export function useAssuranceColors() {
    const companyStore = useCompanyStore();
    const assuranceColors = computed(() => companyStore.assuranceColors);
    const assuranceLabels = computed(() => companyStore.assuranceLabels);
    return { assuranceColors, assuranceLabels };
}
